import * as types from './types';

const INITIAL_STATE = {
  fetching: false,
  fetchError: null,
  ingredient: null,
  saveSuccessful: null,
  deleteSuccessful: null,
  convertSuccessful: null,
  ingredientGroups: [],
  ingredientSources: [],
  fetchingGroups: false,
  fetchingSources: false,
  recipesWithIngredient: [],
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.MANAGE_INGREDIENT_SET_SAVE_SUCCESSFUL:
      return { ...state, saveSuccessful: payload };

    case types.MANAGE_INGREDIENT_SET_DELETE_SUCCESSFUL:
      return { ...state, deleteSuccessful: payload };

    case types.MANAGE_INGREDIENT_SET_CONVERT_TO_RECIPE_SUCCESSFUL:
      return { ...state, convertSuccessful: payload };

    case types.MANAGE_INGREDIENT_FETCH_SUCCESS:
      return {
        ...state,
        ingredient: payload,
      };

    case types.MANAGE_INGREDIENT_FETCHING:
      return {
        ...state,
        fetching: payload,
      };

    case type.MANAGE_INGREDIENT_FETCHING_MEASURES:
      return { ...state, fetchingMeasures: payload };

    case types.MANAGE_INGREDIENT_FETCHING_GROUPS:
      return { ...state, fetchingGroups: payload };

    case types.MANAGE_INGREDIENT_FETCHING_SOURCES:
      return { ...state, fetchingSources: payload };

    case types.MANAGE_INGREDIENT_FETCH_ERROR:
      return {
        ...state,
        fetchError: payload,
      };

    case types.MANAGE_INGREDIENT_CLEAR_ERRORS:
      return {
        ...state,
        fetchError: null,
        recipesWithIngredient: [],
      };

    case types.MANAGE_INGREDIENT_SET_INGREDIENT_GROUPS:
      return { ...state, ingredientGroups: payload };

    case types.MANAGE_INGREDIENT_SET_INGREDIENT_SOURCES:
      return {
        ...state,
        ingredientSources: payload,
      };

    case types.MANAGE_INGREDIENT_SET_RECIPES_WITH_INGREDIENT:
      return {
        ...state,
        recipesWithIngredient: payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/manageingredient/state/editingredient/reducer.js